import React from "react";
import "../styles/InscriptionInput.css";

export default class InscriptionInput extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    }
  }

  validate = (e) => {
    let isValid = true;
    if (this.props.validation === "text") {
      isValid = new RegExp(/^[a-zA-Z áéíóúñÁÉÍÓÚÑ_-]*$/).test(e.target.value)
    } else if (this.props.validation === "number") {
      isValid = new RegExp(/^[0-9]*$/).test(e.target.value)
    } else if (this.props.validation === "alphanumeric"){
      isValid = new RegExp(/^[0-9a-zA-Z]*$/).test(e.target.value)
    } else if (this.props.validation === "colombianPhone") {
      // Validación para números de celular colombianos (10 dígitos, comenzando con 3)
      //isValid = new RegExp(/^3[0-9]{9}$/).test(e.target.value);
      
      // Si es el campo de confirmación, verificar que coincida con el teléfono original
      if (this.props.name === "responsiblePhoneContactConfirm" && this.props.value) {
        const originalPhone = document.getElementById("responsiblePhoneContact").value;
        isValid = isValid && e.target.value === originalPhone;
      }
    } else if (this.props.validation === "email") {
      // Validación de formato de email
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      isValid = emailRegex.test(e.target.value);
      
      // Si es el campo de confirmación, verificar que coincida con el email original
      if (this.props.name === "responsibleEmailConfirm" && this.props.value) {
        const originalEmail = document.getElementById("responsibleEmail").value;
        isValid = isValid && e.target.value === originalEmail;
      }
    }
    this.setState({
      isValid: isValid
    })
    if (this.props.collectValidations) {
      this.props.collectValidations(this.props.name, isValid);
    }
  }

  getMessage = () => {
    if (this.props.validation === "text") {
      return `Sólo se admiten caracteres alfabeticos`
    } else if (this.props.validation === "number") {
      return `Sólo se permite catecteres numéricos`
    } else if (this.props.validation === "alphanumeric") {
      return `Sólo se permite catecteres alfanuméricos`
    } else if (this.props.validation === "colombianPhone") {
      if (this.props.name === "responsiblePhoneContactConfirm") {
        return `El número debe coincidir con el número anterior`
      }
      return `El número debe tener 10 dígitos comenzando con 3`
    } else if (this.props.validation === "email") {
      if (this.props.name === "responsibleEmailConfirm") {
        return `Ingrese un correo electrónico válido y asegúrese que coincida con el correo anterior`
      }
      return `Ingrese un correo electrónico válido`
    }
  }

  handleChange = (e) => {
    const value = e.target.value;
    if (this.props.validation === "colombianPhone" && value.length > 15) {
      return;
    }
    this.validate(e);
    this.props.handleChange(e);
  }

  handleCopy = (e) => {
    e.preventDefault();
    return false;
  }

  handlePaste = (e) => {
    e.preventDefault();
    return false;
  }

  handleCut = (e) => {
    e.preventDefault();
    return false;
  }

  render() {
    return (
      <>
        <label className="form-label-custom">{this.props.label}</label>
        <div className="form-label-group">
          <input type="text"
            id={this.props.name}
            name={this.props.name}
            className={`form-control inscription-input ${this.props.readOnly ? 'readonly' : ''}`}
            required
            onChange={this.handleChange}
            onBlur={this.props.handleBlur}
            value={this.props.value}
            maxLength={this.props.validation === "colombianPhone" ? 15 : undefined}
            readOnly={this.props.readOnly}
            autoComplete={this.props.autoComplete || "on"}
            onCopy={this.handleCopy}
            onPaste={this.handlePaste}
            onCut={this.handleCut}
          />
        </div>
        {!this.state.isValid ? (
          <span className="error-message">{this.getMessage()}</span>
        ) : null}
      </>
    )
  }
}

